/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import { withRouter } from "react-router-dom";

import Drawer from "@material-ui/core/Drawer";
import { withStyles } from "@material-ui/core/styles";

import logo from "../../../assets/sainapse_logo2.png";
import { connect } from "react-redux";

import SectionItem from './components/SectionItem'
import ScreenItem from './components/ScreenItem'

import {
  loadAuthToken,
  saveLoggedInUserInfo,
  loadLoggedInUserInfo,
} from "../../../state_management/localStorage";

// import routes from "../../../configs/screens/routes";
import {
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  Collapse,
  Divider,
  Typography,
} from "@material-ui/core";

import { ExpandLess, ExpandMore } from '@material-ui/icons'
import { config } from "@fortawesome/fontawesome-svg-core";

const styles = (theme) => ({
  drawer: {
    width: "20vw",
    height : '100%',
    overflow : 'auto'
  },
  li: {
    width: "100%",
    margin: 0,
  },
  nested: {
    width: "100%",
    margin: 0,
    paddingLeft: theme.spacing(4),
  },
});

class AppDrawer extends Component {
  state = {};

  renderMenu = () => {
    let user_info = loadLoggedInUserInfo()
    let routes = JSON.parse(sessionStorage.getItem('ui_routes')) !== null ? JSON.parse(sessionStorage.getItem('ui_routes')) : null
    if (routes !== null) {
      let menu = routes.drawer.map((item) => {
        if (item.type === "section") {
          return (
            <SectionItem 
              id = {"sidebar-section-" + item.name.replace(/\s/g, "")}
              key = {item.id} 
              config = {item} 
              goToPage = {(path) => this.goToPage(path)} level = {1}
              cur_route = {this.props.location.pathname}
            />
          )
        } else {
          return (
            <ScreenItem 
              id = {"sidebar-screen-" + item.name.replace(/\s/g, "")}
              key = {item.route} 
              config = {item} 
              goToPage = {(path) => this.goToPage(path)} level = {1}
              cur_route = {this.props.location.pathname}
            />
          )
        }
      });
  
      return menu;
    }
  };

  isAuthorized = (rolesAllowed, loggedInUserRoles) => {
    //if any one of logged in user roles are ther in roles allowed , he is authorized

    try {
      for (let i = 0; i < loggedInUserRoles.length; i++) {
        if (rolesAllowed.includes(loggedInUserRoles[i])) {
          return true;
        }
      }
      return true;
    } catch (err) {
      return true;
    }
  };

  goToPage = (path) => {
    this.props.toggle();
    this.props.history.push({
      pathname: path,
    });
  };

  goToHome = () => {
    this.props.toggle();
    this.props.history.push({
      pathname: "/",
    });
  };

  renderLogo = () => {
    return (
      <Fragment>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            padding: "10px",
          }}
          onClick={() => this.goToHome()}
        >
          <img style={{ height: "30px" }} src={logo} alt="logo" />
        </div>
        <Divider />
        {/* <Typography
          style={{ marginBottom: "25px", width : '100%' }}
          align="center"
          variant="caption"
          display = "block"
        >
          v1.9
        </Typography> */}
      </Fragment>
    );
  };

  render() {
    const { classes } = this.props;
    console.log("Drawer state: ", this.state);
    return (
      <Drawer
        className={classes.drawer}
        anchor="left"
        open={this.props.open}
        onClose={this.props.toggle}
      >
        <div style = {{width : '15vw', height : '100%'}} id = "app-sidebar">
          {this.renderLogo()}
          {console.log("Routes Drawer :", this.renderMenu())}
          <List component = "nav">
            {this.renderMenu()}
          </List>
        </div>
      </Drawer>
    );
  }
}

let mapStateToProps = (state, props) => {
  return {
    loggedInUserRoles: state.logged_in_user_info
      ? state.logged_in_user_info.roles
      : [],
  };
};

export default withRouter(connect(mapStateToProps)(withStyles(styles)(AppDrawer)));
